'use strict';
var slideOpts = (200, "swing");

var app = angular.module("app", ['ngMap']);

app.config(function ($locationProvider, $httpProvider) {
    $locationProvider.html5Mode({
        enabled: true,
        requireBase: true
    });    
});


(function () {
    'use strict';

    app.service("dataService", dataService);
    dataService.$inject = ['$http', '$q'];

    app.service("mapService", mapService);
    function mapService() {

        this.options =
        [{ "featureType": "all", "elementType": "geometry", "stylers": [{ "visibility": "on" }] }, { "featureType": "all", "elementType": "geometry.stroke", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [{ "color": "#393a3b" }] }, { "featureType": "administrative.country", "elementType": "labels", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative.province", "elementType": "labels", "stylers": [{ "visibility": "on" }] }, { "featureType": "administrative.locality", "elementType": "labels", "stylers": [{ "visibility": "on" }] }, { "featureType": "landscape", "elementType": "all", "stylers": [{ "color": "#fbfbfb" }] }, { "featureType": "poi", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "road", "elementType": "all", "stylers": [{ "saturation": -100 }, { "lightness": 45 }] }, { "featureType": "road.highway", "elementType": "all", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "water", "elementType": "all", "stylers": [{ "color": "#def0f7" }, { "visibility": "on" }] }];

        this.initMap = function (vm) {
            vm.map.setOptions({ minZoom: 4, zoomControl: false, gestureHandling: 'greedy' });
            vm.map.mapTypes.set('map_style', new google.maps.StyledMapType(this.options));
            vm.map.setMapTypeId('map_style');

            google.maps.event.addDomListener($(".zoom-in")[0], 'click', function () {
                vm.refresh = true;
                vm.map.setZoom(vm.map.getZoom() + 1);
            });
            google.maps.event.addDomListener($(".zoom-out")[0], 'click', function () {
                vm.refresh = true;
                vm.map.setZoom(vm.map.getZoom() - 1);
            });

            vm.map.controls[google.maps.ControlPosition.TOP_LEFT].push($(".map-zoom-icons")[0]);
            $(".map-zoom-icons").show();

            vm.map.controls[google.maps.ControlPosition.TOP_RIGHT].push($(".map-reload-icons")[0]);
            $(".map-reload-icons").show();
            if ($(window).width() > 767) {
                $(".map-reload-button").hide();
            } else {
                $(".map-reload-checkbox").hide();
                $(".map-reload-button").hide();
            }

            google.maps.event.addDomListener($(".map-reload-button")[0], 'click', function () {
                vm.refresh = true;
                vm.searchThisArea();
            });
        };
    }

    app.filter("trust", ['$sce', function ($sce) {
        return function (htmlCode) {
            return $sce.trustAsHtml(htmlCode);
        }
    }]);

})();


(function () {
    'use strict';    
    app.directive("select", select);

    function select() {
        return {
            restrict: 'E',
            link: link
        };

        function link($scope, elm, attrs) {
            $(elm).selectpicker({dropupAuto: false});
        }
    }

    app.directive("mapSideBar", mapSideBar);

    function mapSideBar() {
        return {
            restrict: 'C',
            link: link
        };

        function link($scope, elm, attrs) {
            var windowW = window.innerWidth;
            $('.items-map-sidebar-listing').on('click', '.sidebar-list-item-dropdown', function (e) {
                var $this = $(this);
               
                if (windowW > 767) {

                    e.preventDefault();
                    var itemDiv = $this.parent();

                    var isCurrentItemHidden = $this.next('.sidebar-list-item-dropdown-content').is(':hidden');
                    
                    var onSlideUp = function (timeout) {
                        // open the clicked content
                        $(" .sidebar-list-item-dropdown-content", itemDiv).toggleClass("open");

                        $(itemDiv).addClass('active') //highlight the current item
                            .parent().addClass('open'); //

                        setTimeout(function () {
                            // Slide down the clicked content                            
                            $(" .sidebar-list-item-dropdown-content", itemDiv).slideDown(slideOpts);
                        }, timeout);
                    };
                    
                    // Slide up all the content                    
                    var $visibleContents = $(".sidebar-list-item-dropdown-content:visible", $('.sidebar-list-item').not(itemDiv));
                    if ($visibleContents.length > 0) {                        
                        $visibleContents.slideUp(slideOpts, function() {
                            if (isCurrentItemHidden) {
                                onSlideUp(400);
                            }
                        });                        
                    }
                    else if (isCurrentItemHidden) {
                        onSlideUp(0);
                    }
                }
            });

            if (windowW > 991) {

                var createScrollBar = function (elm) {

                    var getNetPropertySidebarHeight = function () {                        
                        return $("ng-map").height() - $(".properties-map-sidebar-header").height();                        
                    };

                    $(elm)
                        .slimScroll({
                            width: '100%',
                            height: getNetPropertySidebarHeight(),
                            position: 'right',
                            alwaysVisible: true,
                            distance: 0,
                            start: 'top',
                            railVisible: true,
                            allowPageScroll: false,
                            disableFadeOut: false
                        });

                    var resizeElementAndSlimScrollHeight = function () {                        
                        var mapContainerHeight = getNetPropertySidebarHeight();
                        var $elm = $(elm);
                        $elm.add($elm.closest('.slimScrollDiv')).height(mapContainerHeight);
                    };

                    $(window).on('resize', resizeElementAndSlimScrollHeight);
                    $('.properties-map-search-filters').on('toggle', resizeElementAndSlimScrollHeight);
                };

                if ($('.map-side-bar').length > 0) {
                    $.ajax({
                        url: "/WWW_shared/Assets/js/jquery.slimscroll.min.js",
                        dataType: 'script',
                        success: function success() {
                            createScrollBar(elm);
                        }
                    });
                }
                
                $scope.$watchCollection(
                    "vm.data",
                    function (newValue, oldValue) {
                        if ($(elm).slimScroll != null) {
                            $(elm).slimScroll({ destroy: true });
                            createScrollBar(elm);
                        }
                    }
                );
            }

        }
    }

    app.directive("typeahead", typeahead);
    typeahead.$inject = ['dataService', '$location', '$timeout'];

    function typeahead(dataService, $location, $timeout) {
        return {
            restrict: 'A',
            link: link
        };

        function link($scope, elm, attrs) {

            $(elm).typeahead({
                minLength: 3,
                highlight: true
            },
            {
                displayKey: 'Name',
                limit: 50,
                source: function(query, syncResults, asyncResults) {
                    var req = dataService.suggest(query, $scope.vm.filter.categories || "");
                    handlePendingRequests($scope.vm, "suggest", req);

                    req.promise.then(function(res) {                                               
                        asyncResults(res.data.Data);
                    });   
                },
                templates: {
                    suggestion: function (data) {
                        return '<p>' + data.Name + '</p>';
                    }
                }
            });
            $(elm).bind('typeahead:select', function (ev, item) {
                $scope.vm.searchSelectedItem = item;
                if (item.Type === "Merchant") {
                    $scope.vm.filter.categories = "";
                    $scope.vm.filter.merchantID = item.ID;
                    $scope.vm.filter.suburb = null; 
                    $scope.vm.filter.cuisineID = null;
                }                
                if (item.Type === "Suburb") {
                    $scope.vm.filter.suburb = item.ID;
                    $scope.vm.filter.merchantID = null;                    
                    $scope.vm.filter.cuisineID = null;
                }
                if (item.Type === "Category") {
                    $scope.vm.filter.categories = "" + item.ID;
                    $scope.vm.filter.suburb = null;
                    $scope.vm.filter.merchantID = null;
                    $scope.vm.filter.cuisineID = null;
                    $scope.vm.filter.searchTerm = null;
                }
                if (item.Type === "Cuisine") {
                    $scope.vm.filter.categories = "";
                    $scope.vm.filter.cuisineID = item.ID;
                    $scope.vm.filter.suburb = null;
                    $scope.vm.filter.merchantID = null;
                }
                $location.search($scope.vm.filter);
                $scope.vm.setCategoriesFromUrl();
                $scope.vm.search(false);
            });
            $(elm).bind('typeahead:change', function (ev, item) {
                if ($scope.vm.searchSelectedItem == null || $scope.vm.searchSelectedItem.Name !== item) {
                    $scope.vm.filter.merchantID = null;                    
                    $scope.vm.filter.suburb = null;
                    $scope.vm.filter.cuisineID = null;
                    $(elm).typeahead('val', "");
                    $scope.vm.filter.searchTerm = "";
                    $scope.vm.searchSelectedItem = null;
                    $timeout(function () {
                        $scope.vm.setBounds();
                        $location.search($scope.vm.filter);
                    });
                }
            });
        }
    }   

})();


(function () {
    'use strict';

    app.controller("searchCtrl", searchCtrl);

    searchCtrl.$inject = ['dataService', 'NgMap', '$location', '$timeout', '$sce', '$compile', '$scope', '$filter', 'mapService'];
    function searchCtrl(dataService, NgMap, $location, $timeout, $sce, $compile, $scope, $filter, mapService) {
        var vm = this;
        vm.showloading = true;
        vm.data = [];
        vm.map = null;
        vm.filter = $location.search();
        vm.filterData = {
            categories: [],
            countries: [],
            areas: [],
            offerTypeCategory: []
        };
        vm.search = search;
        vm.searchFilter = searchFilter;
        vm.markers = [];        
        vm.markerClusterer = null;
        vm.infoWindows = [];
        vm.showDetail = showDetail;
        vm.selectPin = selectPin;        
        vm.togglesearch = togglesearch;
        vm.togglesort = togglesort;
        vm.locationTextChanged = locationTextChanged;                
        vm.noData = false;        
        vm.closeInfo = closeInfo;
        vm.searchNearMe = searchNearMe;
        vm.nearMeLocation = null;
        vm.searchRegion = searchRegion;
        vm.countryChanged = countryChanged;
        vm.handlePendingRequests = handlePendingRequests;
        vm.filterBySuggestion = filterBySuggestion;
        vm.addToFavourites = addToFavourites;
        vm.removeFromFavourites = removeFromFavourites;
        vm.showItemOnRight = showItemOnRight;
        vm.setBounds = setBounds;
        vm.selectallcategory = selectallcategory;
        vm.setAllCategory = setAllCategory;
        vm.selectalloffers = selectalloffers;
        vm.setAllOffers = setAllOffers;
        vm.fixPageHeight = fixPageHeight;
        vm.isInit = false;
        vm.mapVisibleArea = null;
        vm.switchView = switchView;
        vm.searchOrder = searchOrder;
        vm.modalItem = {};
        vm.setCategoriesFromUrl = setCategoriesFromUrl;
        vm.setOfferTypesFromUrl = setOfferTypesFromUrl;
        vm.setDefaultLocation = setDefaultLocation;
        vm.toggleOtherLocations = toggleOtherLocations;
        vm.displayOtherLocations = displayOtherLocations;
        vm.quickSearch = quickSearch;
        vm.getOfferLink = getOfferLink;
        vm.rememberInfo = rememberInfo;
        vm.isFitBouds = false;
        vm.zoomchanged = zoomchanged;
        vm.goToOffer = goToOffer;
        vm.searchThisArea = searchThisArea;
        vm.searchOnMapMove = true;

        init();

        navigator.geolocation.getCurrentPosition(function(position) {
            vm.GetCurrentUserLocation = position.coords;
            window.current_location = position.coords.latitude + ',' + position.coords.longitude;

            setDistances();
            if (vm.map != null && $.isEmptyObject(vm.filter)) {
                vm.filter.searchTerm = "";
                setBounds();
                vm.map.setZoom(12);
                vm.map.panTo(new google.maps.LatLng(vm.GetCurrentUserLocation.latitude, vm.GetCurrentUserLocation.longitude));                
                search(false);
            }            
        });

        function setDistances() {
            if (vm.data != null) {
                vm.data.forEach(function(item) {
                    setDistance(item.Locations);
                });
            }
            if (vm.listData != null) {
                vm.listData.forEach(function(item) {
                    setDistance(item.Locations);
                });
            }
            if (vm.modalItem != null && vm.modalItem.Location != null) {
                setDistance([vm.modalItem.Location]);
            }
        }

        function setDistance(data) {
            if (vm.GetCurrentUserLocation != null) {
                $timeout(function() {

                    if (data != null) {
                        data.forEach(function(item) {                            
                            if (item.Distance <= 0) {
                                var d =
                                    getDistanceFromLatLonInKm(vm.GetCurrentUserLocation.latitude,
                                        vm.GetCurrentUserLocation.longitude,
                                        item.Lat,
                                        item.Lng);
                                item.Distance = d.toFixed(0);
                            }
                            vm.markers.forEach(function(m) {
                                if (m.item.ID === item.ID) {
                                    if (item.Distance != null) {
                                        if ((typeof item
                                            .Distance ===
                                            'string' ||
                                            item.Distance instanceof String)) {
                                            item.Distance = parseFloat(item.Distance);
                                        }
                                    }
                                    if (m.infowindow != null) {
                                        var info = $(m.infowindow.content_).find(".map-info-distance");
                                        info.show();
                                        if (item.Distance != null) {
                                            info.text(item.Distance.toFixed(0).toString() + "kms away");
                                        }
                                    }
                                }
                            });
                        });                        
                    }

                });
            }
        }

        function filterBySuggestion(e) {            
            if (e.keyCode === 13) {
                e.preventDefault();
                if (vm.filter.searchTerm === "") {
                    vm.filter.suburb = null;
                    vm.filter.merchantID = null;
                    vm.filter.cuisineID = null;
                    $location.search(vm.filter);
                }
                search(false);
            }            
        }

        function countryChanged() {
            var country = vm.filter.country = vm.country;
            if (country != null && country !== '') {
                dataService.getAreas(country).then(function(res) {
                    vm.filterData.areas = res.data.Data;
                    $timeout(function() {
                        $("select").selectpicker('refresh');
                    });
                });
            } else {
                vm.filterData.areas = [];
                $timeout(function () {
                    $("select").selectpicker('refresh');
                });
            }
        }

        function searchNearMe() {
            vm.filterData.searchRegion = false;
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (position) {                    
                    vm.nearMeLocation = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                    vm.GetCurrentUserLocation = position.coords;
                    window.current_location = position.coords.latitude + ',' + position.coords.longitude;
                }, function(err) {
                    alert("Location service is disabled.");
                }, { enableHighAccuracy: true, maximumAge: 10000 });
            }
        }

        function searchRegion() {
            vm.filterData.searchRegion = true;
            vm.nearMeLocation = null;
        }

        
        function createCustomMarker(item) {
            var latLng = new google.maps.LatLng(item.Lat, item.Lng);
            var bounds = new google.maps.LatLngBounds(latLng, latLng);

            var baseImg = '/www_fv/assets/icons/map/map_pin.png';
            if (vm.customPin != null && vm.customPin !== "") {
                baseImg = vm.customPin;
            }

            return new CustomMapPin(bounds, baseImg, item, vm.map);
        }

        function offsetCenter(latlng, offsety) {

            // latlng is the apparent centre-point
            // offsetx is the distance you want that point to move to the right, in pixels
            // offsety is the distance you want that point to move upwards, in pixels
            // offset can be negative
            // offsetx and offsety are both optional

            var scale = Math.pow(2, vm.map.getZoom());

            var worldCoordinateCenter = vm.map.getProjection().fromLatLngToPoint(latlng);
            var pixelOffset = new google.maps.Point(0, (offsety / scale) || 0);

            var worldCoordinateNewCenter = new google.maps.Point(
                worldCoordinateCenter.x - pixelOffset.x,
                worldCoordinateCenter.y + pixelOffset.y
            );

            var newCenter = vm.map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);

            vm.map.setCenter(newCenter);

        }
        
        //function createMarkerWithIcon(marker, categoryIcon) {            

        //    var canvasMain = document.createElement("canvas");
        //    canvasMain.width = 50 * 1.2;
        //    canvasMain.height = 83 * 1.2;
        //    var context = canvasMain.getContext("2d");

        //    var canvasImg = document.createElement("canvas");            
        //    var contextImg = canvasImg.getContext("2d");

        //    var baseImg = new Image();            
        //    baseImg.onload = function () {

        //        var iconImg = new Image();                
        //        iconImg.onload = function () {
        //            context.drawImage(baseImg, 0, 0, canvasMain.width, canvasMain.height);

        //            canvasImg.width = iconImg.width;
        //            canvasImg.height = iconImg.height;
        //            contextImg.drawImage(iconImg, 0, 0); 
        //            //resize
        //            resampleImg(canvasImg, 40, 40, true);
                    
        //            context.drawImage(canvasImg, 10, 25);
        //            marker.setIcon(canvasMain.toDataURL());
        //            marker.setVisible(true);
        //        }
        //        iconImg.src = categoryIcon;
        //    }
            
        //    if (vm.customPin != null && vm.customPin !== "") {
        //        baseImg.src = vm.customPin;
        //    } else {
        //        baseImg.src = '/www_fv/assets/icons/map/map_pin.png';
        //    }
        //}

        function addPins(data) {
                        
            if (data == null || data.length === 0) {
                return;
            }

            var hasCoodrinates = false;
            var bounds = new google.maps.LatLngBounds();
            
            data.forEach(function (merchant) {

                var item = merchant.Location;
                item.Offers = merchant.Offers;
                if (item.Lat != null && item.Lng != null) {
                    hasCoodrinates = true;
                } else {
                    return;
                }

                var latLng = new google.maps.LatLng(item.Lat, item.Lng);

                item.iconUrl = null;
                vm.filterData.icons.forEach(function (bc) {
                    if (bc.ID === merchant.BCID && bc.Icon != null) {
                        item.iconUrl = bc.Icon;
                    }
                });
                
                var marker = $.grep(vm.markers, function (m) {
                    return m.item.ID === item.ID;
                })[0];

                if (marker != null) {
                    marker.item = item;
                    bounds.extend(marker.getPosition());
                } else {
                    var pin = '/www_fv/assets/icons/map/map_pin.png'
                    if (vm.customPin != null && vm.customPin !== "") {
                        pin = vm.customPin;
                    }

                    marker = new google.maps.Marker({
                        position: latLng,
                        item: item,
                        map: vm.map,
                        icon: {
                            url: pin,
                            anchor: new google.maps.Point(25, 80),
                        },
                        optimized: false
                    });
                    marker.overlay = createCustomMarker(item);                    

                  //  marker.setVisible(false);

                    //if (item.iconUrl != null) {
                    //    createMarkerWithIcon(marker, item.iconUrl);
                    //    createCustomMarker(item);
                    //    merchant.iconUrl = item.iconUrl;
                    //} else {
                    //    marker.setVisible(true);
                    //}

                    bounds.extend(marker.getPosition());

                    if (item.Offers.length === 1) {

                        var infoOptions = {
                            pixelOffset: new google.maps.Size(-140, -170),
                            infoBoxClearance: new google.maps.Size(1, 1),
                            pane: "floatPane",
                            closeBoxURL: ""
                        };

                        var template = $(".map-info-bubble").clone();
                        template.find(".close").attr("ng-click", "vm.closeInfo(" + item.ID + ")");
                        template.find(".map-info-title").text(merchant.MN);
                        template.find(".map-info-address").text(item.Address);
                        if (item.Distance > 0) {
                            template.find(".map-info-distance").text(item.Distance + "kms away");
                        } else {
                            template.find(".map-info-distance").hide();
                        }

                        item.Offers.forEach(function(o) {
                            var offerDiv = $("<div>").addClass("item");
                            offerDiv.html('<div class="content"><a href="/offer/' + o.BookOfferID + '?location=' + item.ID + '">' + o.BoxText + '</a></div>');
                            template.find(".royalSlider").addClass("royalSlider" + item.ID).append(offerDiv);
                        });

                        var boxText = document.createElement("div");

                        boxText.innerHTML = template.html();
                        $compile(boxText)($scope);
                        infoOptions.content = boxText;
                        marker.infowindow = new InfoBox(infoOptions);
                        vm.infoWindows.push(marker.infowindow);

                        marker.addListener('click', function(e) {
                            closeAllInfos();                            
                            offsetCenter(marker.getPosition(), -70);
                            marker.infowindow.open(vm.map, marker);
                            vm.showDetail(e, this.item);
                            $timeout(function () {                                
                                offsetCenter(marker.getPosition(), -70);
                            });                            
                        });
                    }
                    if (item.Offers.length > 1) {
                        marker.addListener('click', function(e) {
                            closeAllInfos();
                            if (e != null) {
                                vm.modalItem = merchant;                                
                                $(".offers-modal").modal();

                                vm.showDetail(e, this.item);
                            }
                        });
                    }                    
                    vm.markers.push(marker);
                    vm.oms.addMarker(marker);
                }                
            });
            if (!hasCoodrinates) {
                return;
            }

            vm.refresh = false;
            if (vm.filter.area != null || vm.filter.suburb != null || vm.filter.merchantID != null || vm.filter.cuisineID != null) {
                vm.isFitBouds = true;
                vm.map.fitBounds(bounds);
            }
            vm.isFitBouds = false;

            if (vm.map.getZoom() < 20) {
            }

            if (data.length > 0) {
                if (vm.markerClusterer != null) {
                    vm.markerClusterer.addMarkers(vm.markers);
                } else {
                    vm.markerClusterer = new MarkerClusterer(vm.map, vm.markers, getClusterSettings());

                    google.maps.event.addListener(vm.markerClusterer, "clusterclick", function (e) {
                        if (vm.map.getZoom() >= 20) {

                            var markers = e.getMarkers();
                            vm.markerClusterer.removeMarkers(markers);
                            vm.markerClusterer.setZoomOnClick(false);

                            markers.forEach(function(m) {
                                m.setMap(vm.map);
                            });

                            $timeout(function() {
                                google.maps.event.trigger(markers[0], 'click');
                            });
                        } else {
                            vm.markerClusterer.setZoomOnClick(true);
                        }
                    });
                }
                vm.markerClusterer.setMap(vm.map);
            }

        }

        function closeInfo(merchantID) {
            vm.markers.forEach(function (m) {
                if (m.item.ID == merchantID) {
                    m.infowindow.close(vm.map, m);
                    return;
                }
            });
        }

        function getClusterSettings() {
            return {
                //maxZoom: 19, TODO: there is issue when max zoom (20) and places are very close, but not same location
                styles: [
                {
                    url: "/www_fv/assets/icons/map/cluster-icon.png",                                        
                    textColor: "#fff",
                    textSize: 22,
                    height: '53',
                    width: '53',
                    fontFamily: 'HelveticaNeueLTStd-BdCn',
                    fontWeight: 'normal',
                    lineHeight: '51px',
                    anchorIcon: [17, 26]
                }]
            }
        }

        function clearClusters() {
            if (vm.oms.getMarkers().length > 0) {
                //vm.oms.clearMarkers();
                vm.oms.unspiderfy();
            }

            if (vm.markerClusterer != null) {
                vm.markerClusterer.clearMarkers();
                vm.markerClusterer.setMap(null);
            }            

            var toRemove = [];
            vm.markers.forEach(function (m) {                
                var show = $.grep(vm.data, function (item) {
                    return m.item.ID === item.Location.ID;
                }).length > 0;
                if (!show) {
                    m.setMap(null);
                    if (m.infowindow != null) {
                        m.infowindow.close();
                    }
                    toRemove.push(m);

                }
                
            });
            toRemove.forEach(function(m) {
                var i = vm.markers.indexOf(m);
                vm.markers.splice(i, 1);
                m.overlay.setMap(null);
            });
        }

        function setBounds() {
            var map = vm.map;
            vm.filter.centerLat = map.getCenter().lat();
            vm.filter.centerLng = map.getCenter().lng();
            vm.filter.zoom = map.getZoom();
        }

        
        function getSearchFilter() {
            var isMapVisible = $(".search-map").width() > 0;

            var categoriesIDs = [];
            if (vm.filter.categories != null && vm.filter.categories.length > 0) {
                categoriesIDs = vm.filter.categories.split(',');
            }

            var offerTypes = [];
            if (vm.filter.offerTypeCategory != null && vm.filter.offerTypeCategory.length > 0) {
                offerTypes = vm.filter.offerTypeCategory.split(',');
            }

            if (vm.map != null && (isMapVisible || vm.nearMeLocation != null)) {
                vm.nearMeLocation = null;
                vm.mapVisibleArea = {
                    NorthEastLat: vm.map.getBounds().getNorthEast().lat(),
                    NorthEastLng: vm.map.getBounds().getNorthEast().lng(),
                    SouthWestLat: vm.map.getBounds().getSouthWest().lat(),
                    SouthWestLng: vm.map.getBounds().getSouthWest().lng(),
                }
            }

            return {
                NorthEastLat: vm.mapVisibleArea != null ? vm.mapVisibleArea.NorthEastLat : null,
                NorthEastLng: vm.mapVisibleArea != null ? vm.mapVisibleArea.NorthEastLng : null,
                SouthWestLat: vm.mapVisibleArea != null ? vm.mapVisibleArea.SouthWestLat : null,
                SouthWestLng: vm.mapVisibleArea != null ? vm.mapVisibleArea.SouthWestLng : null,

                Area: vm.filter.area,                
                MerchantID: vm.filter.merchantID,
                OfferTypeID: vm.filter.offerTypeID,
                Suburb: vm.filter.suburb,
                Cuisine: vm.filter.cuisineID,
                Categories: categoriesIDs,
                OfferTypes: offerTypes,
                Sort: vm.filter.sort,
                SearchTerm: vm.filter.searchTerm,
                Page: 1
            };
        }

        function quickSearch(categories) {
            vm.filter.categories = categories;
            if (vm.filter.cuisineID != null) {
                vm.filter.cuisineID = null;
                vm.filter.searchTerm = null;
            }
            $location.search(vm.filter);
            setCategoriesFromUrl();
            vm.filter.centerLat = null;
            vm.filter.centerLng = null;
            vm.filter.zoom = null;
            vm.filter.merchantID = null;
            vm.filter.searchTerm = null;
            clearEmtyValuesFromFilter();
            setDefaultLocation();
            vm.search(true);
            if ($(".search-filter-panel").is(".slideIn")) {
                togglesearch();
            }
        }
        
        function searchFilter() {
            if (vm.nearMeLocation != null) {
                vm.filter.area = null;
                vm.country = null;
                $timeout(function () {
                    $("select").selectpicker('refresh');
                });

                vm.map.panTo(vm.nearMeLocation);                
                vm.refresh = false;
                vm.map.setZoom(12);
            }
            setUrlFromTopFilter();
            $location.search(vm.filter);
            setBounds();

            if ($(".search-sort-panel").is(".slideIn")) {
                togglesort();
            } else {
                togglesearch();
            }            
            search(false);
        }

        function searchOrder() {
            var sort = vm.filter.sort;
            vm.listData.forEach(function (d) {
                d.Locations = $filter('orderBy')(d.Locations, 'Distance');
                if (d.Offer.PageNo == null || d.Offer.PageNo === "") {
                    d.Offer.PageNo = "XXX";
                }
                if (d.Offer.DistanceSortOrder >= 0) {
                    d.Offer.DistanceSortOrder = d.Locations[0].Distance;
                }
                if (d.Offer.DistanceSortOrder === -10) {
                    d.nameSort = "";
                    d.defaultSort = "";
                }
                else if (d.Offer.DistanceSortOrder === -1) {
                    d.nameSort = d.MN;
                    d.defaultSort = "_";                
                } else {
                    d.nameSort = d.MN;
                    d.defaultSort = "_" + d.MN;
                }
                d.DistanceSortOrder = d.Offer.DistanceSortOrder;
            });

            if (sort === "" || sort == null) {
                vm.listData = $filter('orderBy')(vm.listData, '[defaultSort,Offer.PageNo]');
            }
            if (sort === "distance") {                
                vm.listData = $filter('orderBy')(vm.listData, 'DistanceSortOrder');
            }
            if (sort === "name") {
                vm.listData = $filter('orderBy')(vm.listData, 'nameSort');
            }
            if (sort === "offertype") {
                //if we want to sort like this. we need to rework front end nested repeaters.
                //vm.data = $filter('orderBy')(vm.data, '???');
            }
            if ($(".search-sort-panel").is(".slideIn")) {
                togglesort();
            }            
        }

        function guid() {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000)
                  .toString(16)
                  .substring(1);
            }
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
              s4() + '-' + s4() + s4() + s4();
        }

        function searchThisArea() {
            vm.showloading = true;
            vm.noData = false;
            setBounds();
            vm.filter = vm.filter || {};
            vm.filter.suburb = null;
            vm.filter.searchTerm = null;
            var filter = getSearchFilter();

            callSearch(false, filter);
        }

        function search(isInit, callback) {
            vm.showloading = true;            
            vm.noData = false;
            
            if (!isInit) {
                setBounds();
            }
            
            var filter = getSearchFilter();
            var reqid = guid();
            dataService.searchQueue.push({ g: reqid, f: filter });            

            $timeout(function() {
                var last = dataService.searchQueue[dataService.searchQueue.length - 1];
                if (last.g === reqid) {
                    //call ajax
                    callSearch(isInit, last.f, callback);
                } 
            }, 1000);            
        }

        function callSearch(isInit, filter, callback) {
            var req = dataService.searchOffers(filter);
            handlePendingRequests(vm, "searchOffers", req);            

            req.promise.then(function (res) {                

                if (res.data.Info.Infos.length > 0) {

                    $(".info-modal .modal-body").text(res.data.Info.Infos[0].Message);
                    $(".info-modal").modal();
                }
                              
                vm.noData = res.data.Info.RecordsCount <= 0;
                vm.allHasLocation = true;
                res.data.Data.forEach(function (merchant) {
                    merchant.Locations.forEach(function(item) {
                        if (item.Lat == null || item.Lng == null) {
                            vm.allHasLocation = false;
                        }
                    });
                });

                var listData = jQuery.extend(true, {}, res.data).Data;
                var mapData = jQuery.extend(true, {}, res.data).Data;

                var groupByOffer = [];
                listData.forEach(function (merchant) {
                    merchant.Offers.forEach(function (offer) {
                        var m = jQuery.extend(true, {}, merchant);
                        m.Offer = offer;                        
                        groupByOffer.push(m);
                    });
                });

                var groupByLocations = [];
                mapData.forEach(function (merchant) {
                    merchant.Locations.forEach(function (location) {
                        var m = jQuery.extend(true, {}, merchant);
                        m.Location = location;
                        groupByLocations.push(m);
                    });
                });

                vm.data = groupByLocations;
                vm.listData = groupByOffer;

                setDefaultSort();
                searchOrder();              

                $timeout(function () {
                    if (isInit) {
                        vm.isInit = false;
                    }
                    setDistances();

                    $(".map-reload-button").hide();
                    if ($(window).width() > 767) {
                        $(".map-reload-checkbox").show();
                        $(".map-reload-icons").show();
                    } else {
                        $(".map-reload-icons").hide();    
                    }
                                    

                    clearClusters();                    
                    addPins(vm.data);
                    vm.fixPageHeight();

                    if (callback != null) {
                        callback();
                    }
                    vm.showloading = false;
                });
            });
        }

        function setDefaultSort() {
            if ($(".properties-map-sidebar-refine-search .btn-marker").is(":visible") && vm.filter.sort == null && vm.GetCurrentUserLocation != null) {
                vm.filter.sort = "distance";
            }
            else if (vm.filter.sort == null) {
                vm.filter.sort = "";
            }
        }


        function setUrlFromTopFilter() {
            
            var categories = $.grep(vm.filterData.categories, function (i) { return i.selected === true });
            var categoriesIDs = [];
            categories.forEach(function (cat) { categoriesIDs.push(cat.ID) });
            if (categoriesIDs.length === vm.filterData.categories.length) {
                vm.filter.categories = null;
            } else {
                vm.filter.categories = categoriesIDs.join();
            }


            var offerTypes = $.grep(vm.filterData.offerTypeCategory, function (i) { return i.selected === true });
            var offerTypesValues = [];
            offerTypes.forEach(function (cat) { offerTypesValues.push(cat.Value) });
            if (offerTypesValues.length === vm.filterData.offerTypeCategory.length) {
                vm.filter.offerTypeCategory = null;
            } else {
                vm.filter.offerTypeCategory = offerTypesValues.join();
            }

            if (vm.filter.searchTerm == null) {
                vm.filter.merchantID = null;
                vm.filter.suburb = null;
                vm.filter.cuisineID = null;
                vm.filter.searchTerm = null;
            }


            clearEmtyValuesFromFilter();
        }

        function clearEmtyValuesFromFilter() {
            for (var i in vm.filter) {
                if (vm.filter[i] === null || vm.filter[i] === undefined || vm.filter[i] == "") {
                    if (i !== "minspace" && i !== "minprice") {
                        delete vm.filter[i];
                    }
                }
            }
        }

        function showSingleOfferDetail(item, offerID) {
            var itemDiv = $(".sidebar-list-item-dropdown[data-offer-id=" + offerID + "][data-item-id=" + item.ID + "]");
            if(itemDiv.size() === 0) {
                return;
            }
            $(".sidebar-list-item-dropdown-content", itemDiv.parent()).slideDown(slideOpts, function() {});
        }

        function showDetail(e, item) {
            $timeout(function() {
                vm.selectedID = item.ID;                
            });
            offerRoyalSlider(item);
            var itemDiv = $(".sidebar-list-item[data-item-id=" + item.ID + "]");
            if (itemDiv.size() === 0) {
                return;
            }

            var slideItemToTop = function() {
                var parent = $(".map-side-bar").offset().top;
                var firstDff = $(".map-side-bar div:first").offset().top - parent;

                if ($(".map-side-bar").is(":visible") && $(".map-side-bar").slimScroll != null) {
                    $(".map-side-bar").slimScroll({
                        scrollTo: ($(itemDiv).offset().top - parent - firstDff) + 'px',
                        animate: true
                    });
                }
            }

            $(".sidebar-list-item-dropdown-content", $(".sidebar-list-item").not(itemDiv)).hide();
            $(".sidebar-list-item-dropdown-content", itemDiv).slideDown(slideOpts, function() {
                slideItemToTop();
            });

            slideItemToTop();
        }

        function offerRoyalSlider(item) {
            $timeout(function() {
                $(".royalSlider" + item.ID)
                    .royalSlider({
                        keyboardNavEnabled: false,
                        controlNavigation: "none",
                        sliderDrag: false,
                        autoHeight: true,
                        arrowsNav: false,
                        autoPlay: {
                            enabled: true,
                            pauseOnHover: true,
                            delay: 5000
                        }
                    });
            });
        }

        function closeAllInfos() {
            // Close all the info windows
            vm.infoWindows.forEach(function (info) {
                info.close();
            });
        }

        function getCurrentCluster(itemID) {
            var currentCluster = null;
            var clusters = vm.markerClusterer.getClusters();
            clusters.forEach(function (cl) {
                if (currentCluster == null) {
                    var markers = cl.getMarkers();
                    markers.forEach(function(m) {
                        if (itemID === m.item.ID) {
                            currentCluster = cl;
                        }
                    });
                }
            });
            return currentCluster;
        }
        
        function addIdleCallback(itemID) {
            vm.clusterzoom = true;
            google.maps.event.addListenerOnce(vm.map, 'idle', function () {
                var currentCluster = getCurrentCluster(itemID);
                if (currentCluster != null && currentCluster.getMarkers().length > 1 && vm.map.getZoom() < 20) {
                    addIdleCallback(itemID);
                    vm.isFitBouds = true;
                    vm.map.fitBounds(currentCluster.getBounds());
                    vm.isFitBouds = false;
                } else {
                    if (currentCluster != null) {
                        $timeout(function () {
                            google.maps.event.clearListeners(vm.map, 'zoom_changed');
                            $(currentCluster.clusterIcon_.div_).click();
                            $timeout(function () {
                            vm.map.addListener('zoom_changed', function () {
                                vm.zoomchanged();
                                });                            
                            }, 1000);
                        });
                    }
                    google.maps.event.clearListeners(vm.map, 'idle');
                    vm.clusterzoom = false;
                    removeOtherItems(itemID);
                }
            });
        }

        function removeOtherItems(itemID) {            
            vm.markers.forEach(function(m) {
                if (!vm.map.getBounds().contains(m.getPosition())) {
                    var index = vm.data.indexOf($.grep(vm.data,
                        function(item) { return m.item.ID === item.Location.ID; })[0]);
                    vm.data.splice(index, 1);
                    m.setMap(null);
                    if (m.item.ID === itemID) {
                        $timeout(function() {
                            google.maps.event.trigger(m, 'click');
                        });
                    }
                }
            });
            $timeout(function() {
                vm.data = vm.data;
                vm.markers.forEach(function(m) {
                    if (!vm.map.getBounds().contains(m.getPosition())) {
                        m.setMap(null);
                    }                     
                });
            });
        }

        function selectPin(merchant, location) {
            if (location == null) {
                return;
            }
            vm.selectedID = location.ID;

            if (!$("ng-map").is(":visible") && merchant != null) {
                vm.switchView(true);
            }

            var marker = $.grep(vm.markers, function (m) {
                return m.item.ID === location.ID;
            })[0];
            
            closeAllInfos();

            if (marker == null) {
                return;
            }
            marker.setMap(vm.map);

            var currentCluster = null;
            if (vm.markerClusterer != null) {
                currentCluster = getCurrentCluster(location.ID);
                if (currentCluster != null && currentCluster.getMarkers().length > 1) {
                    if (vm.map.getZoom() < 20) {
                        addIdleCallback(location.ID);
                        vm.isFitBoud = true;
                        vm.map.fitBounds(currentCluster.getBounds());
                        vm.isFitBoud = false;
                    } else {                                        
                        $(currentCluster.clusterIcon_.div_).click();                        
                    }
                }
            }

            $timeout(function () {
                if (marker.infowindow != null) {
                    google.maps.event.trigger(marker, 'click');
                } else {
                    var latLng = marker.getPosition();
                    vm.map.setCenter(latLng);
                }
                if (vm.map.getZoom() > 20) {
                    google.maps.event.clearListeners(vm.map, 'zoom_changed');
                    vm.map.setZoom(20);
                    vm.map.addListener('zoom_changed', function () {
                        vm.zoomchanged();
                    }); 
                }
            });

            if (marker.infowindow != null) {
                // Check if the clicked marker's info window is close or not
                var isInfoWindowOpen = marker.infowindow.getVisible();

                marker.infowindow.open(vm.map, marker);
                // if the info window is not already open
                if (!isInfoWindowOpen) {
                    // open the info window                
                    offerRoyalSlider(location);

                    // pan to the marker position
                    vm.map.panTo(marker.getPosition());
                }
            }
        }

        function filterLocationEmpty() {
            var filterEmpty = $.isEmptyObject(vm.filter) ||
                (Object.keys(vm.filter).length === 1 && Object.keys(vm.filter)[0] === 'categories');
            return filterEmpty
                && (vm.filter.centerLat == null && vm.filter.centerLng == null)
                && vm.filter.area == null && vm.filter.suburb == null && vm.filter.merchantID == null;
        }

        function zoomchanged() {
            if ($(window).width() <= 767) {
                //mobile do not search on map interaction
                $(".map-reload-icons").show(); 
                $(".map-reload-button").show();
                return;
            }

            if (!vm.searchOnMapMove) {
                $(".map-reload-button").show();
                $(".map-reload-checkbox").hide();
                return;
            }
            $(".map-reload-button").hide();
            $(".map-reload-checkbox").show();
            

            if (vm.isInit || vm.clusterzoom || vm.isFitBouds) {
                return;
            }

            if (vm.refresh && vm.filter.area == null && vm.filter.suburb == null && vm.filter.merchantID == null) {
                vm.search(false);
            }
            $timeout(function () {
                setBounds();
                $location.search(vm.filter);
            });

            if (vm.refresh) {
                vm.filter.area = null;
                vm.filter.suburb = null;
                vm.filter.searchTerm = null;
                $('select').selectpicker('refresh');
            }
            vm.refresh = true;
        }

        function init() {
            vm.country = vm.filter.country;

            $('.info-modal').on('show.bs.modal',
                function(e) {
                    $(".modal-backdrop").hide();
                    $timeout(function() {
                            $(".modal.in").after($(".modal-backdrop"));
                        },
                        200).then(function() {
                        $(".modal-backdrop").show();
                    });
                });
                        
            NgMap.getMap().then(function (map) {
                vm.map = map;                
                mapService.initMap(vm);
                vm.fixPageHeight();                

                vm.oms = new OverlappingMarkerSpiderfier(vm.map, { keepSpiderfied: true, nearbyDistance : 40, markersWontHide: true, circleSpiralSwitchover: Infinity });             
                vm.oms.addListener('unspiderfy', function (markers) {
                    var addMarkers = [];
                    var existingMarkers = vm.markerClusterer.getMarkers();

                    var add = true;
                    markers.forEach(function(m) {
                        existingMarkers.forEach(function(exm) {
                            if (exm.item.ID === m.item.ID) {
                                add = false;
                            }
                        });
                        if (add) {
                            addMarkers.push(m);
                        }
                    });

                    vm.markerClusterer.addMarkers(addMarkers);
                });
         
                                
                dataService.loadFilters(vm.country || null).then(function (res) {
                    vm.filterData = res.data.Data;

                    vm.filterData.categories.forEach(function(c) {
                        if (c.Icon.endsWith('svg')) {
                            loadExternalSvg(c.ID + '__icon__svg', c.Icon);                            
                        }
                    });

                    if (vm.filterData.countries != null && vm.filterData.countries.length === 1) {
                        vm.country = vm.filterData.countries[0].ID;                        
                    }

                    vm.customPin = vm.filterData.defaultLocation.Pin;
                    $timeout(function () {
                        $("select").selectpicker('refresh');
                    });

                    setCategoriesFromUrl();
                    setOfferTypesFromUrl();

                    vm.filterData.searchRegion = vm.filter.area != null;
                    
                    setUrlFromTopFilter();

                    setDefaultLocation();

                    if (vm.filter.view !== "map") {
                        vm.switchView();
                    }
                });


                map.addListener("click", function (event) {
                    closeAllInfos();
                });

                map.addListener("dragstart", function (event) {
                    closeAllInfos();
                });

                map.addListener('mousemove', function () {                                    
                    vm.refresh = true;                    
                });

                map.addListener('zoom_changed', function () {
                    vm.zoomchanged();
                });

                map.addListener('dragend',
                    function() {
                        if ($(window).width() <= 767) {
                            //mobile do not search on map interaction
                            $(".map-reload-icons").show();
                            $(".map-reload-button").show();
                            return;
                        }

                        if (!vm.searchOnMapMove) {
                            $(".map-reload-button").show();
                            $(".map-reload-checkbox").hide();
                            return;
                        }
                        $(".map-reload-button").hide();
                        $(".map-reload-checkbox").show();
                      
                        vm.filter.area = null;
                        vm.filter.searchTerm = null;
                        vm.filter.suburb = null;
                        $('select').selectpicker('refresh');

                        if (vm.filter.merchantID == null) {
                            vm.search(false);
                            $timeout(function() {
                                $location.search(vm.filter);
                            });
                        } else {
                            $timeout(function() {
                                setBounds();
                                $location.search(vm.filter);
                            });
                        }
                    });

            });

            angular.element($(window)).bind('resize', function () {                
                vm.fixPageHeight();
                $scope.$digest();
            });

                                        
            watchBack();
        }

        function setDefaultLocation() {
            if (!filterLocationEmpty()) {
                vm.isInit = true;
                if (vm.filter.merchantID != null) {
                }
                else if (vm.filter.suburb != null) {
                }
                else if (vm.filter.centerLat != null && vm.filter.centerLng != null && vm.filter.zoom != null) {
                    vm.map.setCenter(new google.maps.LatLng(vm.filter.centerLat, vm.filter.centerLng));
                    vm.map.setZoom(parseInt(vm.filter.zoom));
                    setBounds();
                } else {
                    if (vm.filterData.defaultLocation == null) {
                        return;
                    }
                    vm.map.setZoom(12);
                    vm.map.panTo(new google.maps.LatLng(vm.filterData.defaultLocation.Lat, vm.filterData.defaultLocation.Lng));
                }
                vm.search(true);
            }
            else if (vm.GetCurrentUserLocation != null) {
                vm.map.setZoom(12);
                vm.map.panTo(new google.maps.LatLng(vm.GetCurrentUserLocation.latitude, vm.GetCurrentUserLocation.longitude));
                $location.search(vm.filter);
                vm.search(false);
            } else {
                if (vm.map == null) {
                    return;
                }
                vm.isInit = true;
                vm.map.setZoom(12);
                if (vm.filterData.defaultLocation != null) {
                    vm.map.panTo(new google.maps.LatLng(vm.filterData.defaultLocation.Lat,
                        vm.filterData.defaultLocation.Lng));
                    if (vm.filterData.defaultLocation.Zoom != null) {
                        vm.map.setZoom(parseInt(vm.filterData.defaultLocation.Zoom));
                    }
                }
                vm.search(true);
            }
        }

        function setCategoriesFromUrl() {
            $("#allCategories").prop("checked", false);
            vm.filterData.categories.forEach(function (cat) {
                cat.selected = false;
            });
            var categories = vm.filter.categories;
            if (categories != null && categories.length > 0) {
                var catIDs = categories.split(',');                
                vm.filterData.categories.forEach(function (cat) {
                    var grouppedCurrentIDs = cat.ID.split(',');
                    var groupedSelected = 0;
                    grouppedCurrentIDs.forEach(function(gID) {
                        catIDs.forEach(function (catID) {
                            if (gID == catID) {                                
                                groupedSelected ++;;
                            }
                        });
                    });
                    if (groupedSelected === grouppedCurrentIDs.length) {
                        cat.selected = true;
                    }                    
                });
            } else {
                vm.filterData.categories.forEach(function(cat) {
                    cat.selected = true;
                });
                $("#allCategories").prop("checked", true);                
            }
        }

        function setOfferTypesFromUrl() {
            $("#allOffers").prop("checked", false);
            var offerTypes = vm.filter.offerTypeCategory;
            if (offerTypes != null && offerTypes.length > 0) {
                var typeValues = offerTypes.split(',');
                vm.filterData.offerTypeCategory.forEach(function (cat) {
                    typeValues.forEach(function (catID) {
                        if (cat.Value == catID) {
                            cat.selected = true;
                        }
                    });
                });
            } else {
                vm.filterData.offerTypeCategory.forEach(function (cat) {
                    cat.selected = true;
                });
                $("#allOffers").prop("checked", true);                
            }
        }

        function locationTextChanged() {
            vm.place = this.getPlace();
            if (vm.place.geometry != null) {                
                vm.map.setCenter(vm.place.geometry.location);
                if (vm.place.geometry.viewport != null) {
                    vm.map.fitBounds(vm.place.geometry.viewport);
                } else {
                    vm.map.setCenter(vm.place.geometry.location);
                    vm.map.setZoom(17);
                }
                saveUserLocation(vm.map.getBounds());
                vm.filter.text = null;
                vm.search(false);                
            }
        }
                
        function togglesearch() {
            var filter = $('.search-filter-panel');
            filter.show();
            filter.toggleClass('slideIn');            
            $('.search-sort-panel').removeClass('slideIn');
            $('.btn-refine').toggleClass('open');
        }

        function togglesort() {
            $(".search-filter-panel").removeClass("slideIn");
            $(".search-sort-panel").toggleClass("slideIn");
        }
        

        function addToFavourites(merchant) {
            dataService.addToFavourites(merchant.MID).then(function (res) {
                merchant.IsMyFavourite = true;
            });
        }

        function removeFromFavourites(merchant) {
            dataService.removeFromFavourites(merchant.MID).then(function (res) {
                merchant.IsMyFavourite = false; 
            });
        }

        function showItemOnRight(merchantID) {
            var marker;
            vm.markers.forEach(function (m) {
                if (m.item.ID == merchantID) {
                    marker = m;
                    return;
                }
            });
            if (marker != null) {
                return vm.map.getBounds().contains(marker.getPosition());
            }
            return false;
        }
        
        function selectallcategory() {
            var check = $("#allCategories").is(":checked");

            vm.filterData.categories.forEach(function(cat) {
                cat.selected = check;
            });
        }

        function setAllCategory(category) {
            var checkCount = 0;
            vm.filterData.categories.forEach(function (cat) {
                if (category.ID !== cat.ID) {
                    cat.selected = false;
                }
                if (cat.selected) {
                    checkCount++;
                }
            });
            $("#allCategories").prop('checked', vm.filterData.categories.length === checkCount);
        }

        function selectalloffers() {
            var check = $("#allOffers").is(":checked");

            vm.filterData.offerTypeCategory.forEach(function (cat) {
                cat.selected = check;
            });
        }

        function setAllOffers() {
            var checkCount = 0;
            vm.filterData.offerTypeCategory.forEach(function (cat) {
                if (cat.selected) {
                    checkCount++;
                }
            });
            $("#allOffers").prop('checked', vm.filterData.offerTypeCategory.length === checkCount);
        }

        function fixPageHeight() {


            $('footer').hide();
            $('body').css({ overflow: 'hidden' });
            var wH = $(window).height(),
                navDiff = (wH - 142);
            if (navDiff < 550) {
                $('header').addClass('sticky condensed');
            } else {
                $('header').removeClass('sticky').removeClass('condensed');
            };
            var mobileMenu = $(".properties-map-sidebar-refine-search .btn-marker:visible");
            var h = wH - $(".properties-map-wrap").offset().top;
            $('.properties-map-table-wrap').css({ height: h + 'px' });
            $("ng-map").parent().height(h);
            $("ng-map").height(h);
            google.maps.event.trigger(angular.element($("ng-map > div"))[0], "resize");

        }

        function switchView(doNotShowMessage) {
            var isMapVisible = $(".search-map").width() > 0;
            if (isMapVisible) {
                vm.mapVisibleArea = {
                    NorthEastLat: vm.map.getBounds().getNorthEast().lat(),
                    NorthEastLng: vm.map.getBounds().getNorthEast().lng(),
                    SouthWestLat: vm.map.getBounds().getSouthWest().lat(),
                    SouthWestLng: vm.map.getBounds().getSouthWest().lng(),
                }
                delete vm.filter["view"];
            } else {
                vm.mapVisibleArea = null;
                vm.filter.view = "map";                

                if (!vm.allHasLocation && localStorage.RememberInfo !== "Remember" && !doNotShowMessage) {
                    $(".info-modal .modal-body").html("Please note some of the web offers cannot be displayed on the map as they dont have locations. Please switch back to text view to redeem those offers online");
                    $(".modal-content__remember-info").show();
                    $(".info-modal").modal();
                }
            }
            
            $location.search(vm.filter);

            $(".search-sort-panel").removeClass("slideIn");

            var filter = $('.search-filter-panel');
            filter.removeClass('slideIn');
            $(".properties-map-wrap, .properties-map-sidebar-header").toggleClass('open');
            google.maps.event.trigger(vm.map, 'resize');
           
        }

        function watchBack() {
            window.onpopstate = function (event) {
                var _vm = angular.element($("div[data-ng-app]")).scope().vm;
                _vm.filter = $location.search();
                _vm.isInit = true;

                _vm.setCategoriesFromUrl();
                _vm.setOfferTypesFromUrl();
                _vm.setDefaultLocation();
            };
        }


        function toggleOtherLocations(merchant) {
            var show = !merchant.showAll;
            merchant.showAll = show;
            var elems = $(".merchant__other-offers[data-offer-id=" + merchant.Offer.BookOfferID + "]");            
            if (show) {
                elems.hide().slideDown();                
            } else {
                elems.slideUp().hide();                
            }
        }

        function displayOtherLocations(merchant) {
            if (vm.data == null) {
                return false;
            }
            var hasMore = merchant.Locations.length > 1;
            var hasAnyAddress = false;
            merchant.Locations.forEach(function (l, i) {
                if (l.DisplayType !== 'None' && i > 0) {
                    hasAnyAddress = true;
                }
            });
            return hasMore && hasAnyAddress;
        }

        function getOfferLink(merchant, location) {
            var link = "/offer/" + merchant.Offer.BookOfferID + "?location=" + location.ID;
            if (merchant.Offer.DisplayTemplateCode === "WebLink" || merchant.Offer.BookOfferType === "Online") {
                link += "&redirect=sso";                
            }
            return link;
        }

        function goToOffer(merchant, location) {
            var url = getOfferLink(merchant, location);
            window.location = url;
        }

        function rememberInfo() {
            localStorage.RememberInfo = "Remember";
        }
    }
})();